import { useCallback, type RefObject } from "react";
import type { IOption } from "../DropdownOption";

type Openable = { close: () => void };

export function useDropdownMenuHandlers(
	ref: RefObject<HTMLDivElement | null>,
	openable: Openable,
	selectedOptions: IOption[],
	onSelect?: (newOption: IOption, options: IOption[]) => void,
): { handleSelect: (option: IOption) => void; handleClickOutside: (event: MouseEvent) => void } {
	const handleSelect = useCallback(
		(option: IOption) => {
			if (option.notSelectable) return;
			const newOptions = selectedOptions.some((s) => s.id === option.id) ? selectedOptions : [...selectedOptions, option];
			onSelect?.(option, newOptions);
			openable.close();
		},
		[onSelect, openable, selectedOptions],
	);
	const handleClickOutside = useCallback(
		(event: MouseEvent): void => {
			if (ref.current && !ref.current.contains(event.target as Node)) openable.close();
		},
		[openable, ref],
	);
	return { handleSelect, handleClickOutside };
}
